import * as d3 from 'd3-selection';
export class BaseElement {
    constructor(element) {
        this.$element = $(element);
        this.rootElement = d3.select(element);
        this.model = JSON.parse(this.rootElement.attr('data-model'));
    }
}
